import React from 'react';
import { Square, Stack } from '@grubhubprod/gh-cookbook-react';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { CreateReportFormProvider } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/CreateReportForm/CreateReportFormProvider';
import { CreateReportForm } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/CreateReportForm/CreateReportForm';

export const CreateReportsPage: React.FC = () => {
  return (
    <Square inset="lg">
      <Stack y="lg">
        <PageHeader>
          <PageTitle title="Create Reports" />
        </PageHeader>
        <CreateReportFormProvider>
          <CreateReportForm />
        </CreateReportFormProvider>
      </Stack>
    </Square>
  );
};
